/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Route } from 'react-router-dom';
import Map from 'pages/map/index';
import Dashboard from 'routes/dashboard';
import WhatsNextRoom from 'pages/whatsNextRoom/index';
import DigitalResourceMap from 'pages/digitalResourceMap';
import ExpiredSubscription from 'pages/subscriptionExpired';

const getProtectedRoutes = (
  userType: string,
  isActiveSubscription: boolean
): JSX.Element[] => {
  let routes: any = [];
  if (userType === 'parent' && !isActiveSubscription) {
    routes = [
      <Route key="dashboard" path="/dashboard">
        <Dashboard isActiveSubscription={isActiveSubscription} />
      </Route>,
      <Route key="expired-subscription" path="/expired-subscription">
        <ExpiredSubscription />
      </Route>,
    ];
  }
  if (userType === 'parent' && isActiveSubscription) {
    routes = [
      <Route key="map" path="/map">
        <Map />
      </Route>,
      <Route key="digital-map" path="/digital-map">
        <DigitalResourceMap />
      </Route>,
      <Route key="next-room" path="/next-room">
        <WhatsNextRoom />
      </Route>,
      <Route key="dashboard" path="/dashboard">
        <Dashboard isActiveSubscription={isActiveSubscription} />
      </Route>,
    ];
  }
  if (userType === 'teacher') {
    routes = [
      <Route key="dashboard" path="/dashboard">
        <Dashboard isActiveSubscription />
      </Route>,
    ];
  }
  return routes;
};

export default getProtectedRoutes;
